import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { useLocation, useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { Theme } from 'styles/ThemeTyping';
import createRole, { RoleCreateRequest } from 'fetches/rolesAndPermissions/createRole';
import { HOME_URL, ROLES_AND_PERMISSIONS_URL } from 'components/Router/consts';

import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Loader from 'components/Loader';
import Page from 'components/Page/newComponents';
import RoleCreateForm from 'pages/RolesAndPermissions/RoleConfiguration/RoleCreateForm';
import RoleManageForm from 'pages/RolesAndPermissions/RoleConfiguration/RoleManageForm';

interface Props {
  status: number;
}

function RoleConfiguration({ status }: Props) {
  const classes = useStyles();
  const location = useLocation();
  const fromEditUserId = _get(location, ['state', 'fromEditUserId']);
  const history = useHistory();
  const dispatch = useDispatch();
  const [currentSlideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    if (location.pathname.includes('create-role')) {
      setSlideIndex(0);
    } else if (location.pathname.includes('roles')) {
      setSlideIndex(1);
    }
  }, [location]);

  const handleCreateRole = (data: RoleCreateRequest) => {
    dispatch(createRole(data));
  };

  const handleClose = () => {
    if (fromEditUserId) {
      history.push(`${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/users/${fromEditUserId}`);
    } else {
      history.push(`${HOME_URL}${ROLES_AND_PERMISSIONS_URL}`);
    }
  };

  const currentSlideContent =
    currentSlideIndex === 0 ? (
      <RoleCreateForm onClose={handleClose} onSave={handleCreateRole} />
    ) : currentSlideIndex === 1 ? (
      <RoleManageForm onClose={handleClose} fromEditUserId={fromEditUserId} />
    ) : null;

  return (
    <Dialog fullScreen open aria-labelledby="role-configuration">
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography id="role-configuration" variant="h6" className={classes.flex}>
            {currentSlideIndex === 0 ? 'Create Role' : 'Manage Role'}
          </Typography>
          <Button color="inherit" className={classes.cancelButton} onClick={handleClose}>
            Close
          </Button>
        </Toolbar>
      </AppBar>
      <Page classes={{ root: classes.pageRoot }}>
        <Loader status={status}>{() => currentSlideContent}</Loader>
      </Page>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  appBar: {
    position: 'relative',
    backgroundColor: '#2f2f32',
  },
  cancelButton: {
    marginRight: theme.spacing(1),
  },
  flex: {
    flex: 1,
  },
  pageRoot: {
    display: 'flex',
    flex: '1 1 auto',
    height: 'calc(100vh - 64px)',
  },
}));

export default RoleConfiguration;
